import CustomTabs from "@components/CustomTabs"
import {techStacks} from './TabsTechStacks.jsx'
export const TechWeUse = ()=>{
    return(
        <section className="container">

                <CustomTabs techStacks={techStacks} title='Technologies We Use for Mobile App Development'/>
        </section>
        
    )
}